'use client';

import cn from 'classnames';
import type { PropsWithChildren, ReactNode } from 'react';

import { useAccordion } from '../../hooks/useAccordion';
import ChevronIcon from './chevron.icon.svg';
import './AccordionItem.scss';

export type AccordionItemProps = PropsWithChildren & {
    title: string;
    id?: string;
    className?: string;
    actionSlot?: ReactNode;
    defaultOpen?: boolean;
    onOpen?: () => void;
    onClose?: () => void;
    dataTestId?: string;
};

export const AccordionItem = ({
    title,
    id,
    children,
    actionSlot,
    className,
    defaultOpen,
    onOpen,
    onClose,
    dataTestId,
}: AccordionItemProps) => {
    const { detailsRef, contentRef, handleClick } = useAccordion({ defaultOpen, onOpen, onClose });

    return (
        <div id={id} data-testid={id} className={cn('disclosure__item', className)}>
            <details className="disclosure__details" ref={detailsRef}>
                <summary
                    className={cn('disclosure__summary', { 'disclosure__summary--with-action': Boolean(actionSlot) })}
                    onClick={handleClick}
                >
                    <span className="disclosure__title" data-testid={`${dataTestId}-header`}>
                        {title}
                    </span>
                    <span className="disclosure__icon" aria-hidden="true">
                        <ChevronIcon />
                    </span>
                </summary>
                <div className="disclosure__content" ref={contentRef}>
                    <div className="disclosure__content-inner">{children}</div>
                </div>
            </details>
            {actionSlot && <div className="disclosure__action-slot">{actionSlot}</div>}
        </div>
    );
};
